import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../layouts/index";
import Grid from "@mui/material/Grid2";
import { Typography, Box } from "@mui/material";
import carouselData from "../data/homeCarousel.json";
import BackgroundImageBottom from "../assets/images/shape_crescent-bottom.png";
import AircraftBackground from "../assets/images/main-homebackground-aircraft-image.png";
import TalktoUs from "../components/pagesComponents/TalktoUs";
import DiscoverSection from "../components/pagesComponents/DiscoverSection";
import AirOperators from "../components/pagesComponents/AirOperators";
import CustomerReviews from "../components/pagesComponents/CustomerReviews";
import LogoCarousel from "../components/pagesComponents/LogoCarousel";
import WinopsTabSection from "../components/pagesComponents/WinopsTabSection";
import ProductFeatures from "../components/pagesComponents/ProductFeatures";
import OpsFeaturesData from "../data/opsFeatures.json";
import ProductBenefits from "../components/pagesComponents/ProductBenefits";
import OpsBenefitsData from "../data/opsBenefits.json";
import WinopsApps from "../components/pagesComponents/WinopsApps";
import IntegrationCarousel from "../components/pagesComponents/IntegrationCarousel";
import OpsCustomerData from "../data/opsCustomerReviews.json";
import { styled } from "@mui/material/styles";
import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SmsSnippet from "../components/SmsSnippet";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ProfileComponent from "../components/pagesComponents/ProfileComponent";
import ModulesTabSectionContent from "../components/pagesComponents/ModulesTabSection";
import SmsWorkshop from "../components/pagesComponents/SmsWorkshop";

const PREFIX = "OpsPage";
const classes = {
  carouselBlock: `${PREFIX}-carouselBlock`,
  carouselImage: `${PREFIX}-carouselImage`,
  indexCarousrlBlockContainer: `${PREFIX}-indexCarousrlBlockContainer`,
  backgroundDesign1: `${PREFIX}-backgroundDesign1`,
  carouselContainerLists: `${PREFIX}-carouselContainerLists`,
  fingertipTitleGrid: `${PREFIX}-fingertipTitleGrid`,
  fingertipTitle: `${PREFIX}-fingertipTitle`,
  fingertipTitle2Grid: `${PREFIX}-fingertipTitle2Grid`,
  homePageTitle: `${PREFIX}-homePageTitle`,
  homePageTitledesc: `${PREFIX}-homePageTitledesc`,
  sliderDiv: `${PREFIX}-sliderDiv`,
  fingertipTitle2: `${PREFIX}-fingertipTitle2`,
  clientsHeadingGrid: `${PREFIX}-clientsHeadingGrid`,
  clientsHeading: `${PREFIX}-clientsHeading`,
  buttonStyles: `${PREFIX}-buttonStyles`,
  homeButtonItem: `${PREFIX}-homeButtonItem`,
  exploreButtonStyle: `${PREFIX}-exploreButtonStyle`,
  demoButtonGrid: `${PREFIX}-demoButtonGrid`,
  demoButtonStyle: `${PREFIX}-demoButtonStyle`,
  productTabLabel: `${PREFIX}-productTabLabel`,
  productTabSelected: `${PREFIX}-productTabSelected`,
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  exploreProductLink: `${PREFIX}-exploreProductLink`,
  tabContainerBlock: `${PREFIX}-tabContainerBlock`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  productTabsContainer: `${PREFIX}-productTabsContainer`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  tabContainerTabs: `${PREFIX}-tabContainerTabs`,
  productImage: `${PREFIX}-productImage`,
  productImageCoreCommand: `${PREFIX}-productImageCoreCommand`,
  productImageOtherThanCoreCommand: `${PREFIX}-productImageOtherThanCoreCommand`,
  exploreAnchorLink: `${PREFIX}-exploreAnchorLink`,
  fingertipTitleSubHeading: `${PREFIX}-fingertipTitleSubHeading`,
  icon: `${PREFIX}-icon`,
  pointsBody: `${PREFIX}-pointsBody`,
  pointsContainer: `${PREFIX}-pointsContainer`,
  highlight: `${PREFIX}-highlight`,
  blueContainer: `${PREFIX}-blueContainer`,
  blueContent: `${PREFIX}-blueContent`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.pointsContainer}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "2rem",
    height: "100%",
  },
  [`& .${classes.icon}`]: {
    color: "green",
    marginRight: "1%",
  },
  [`& .${classes.pointsBody}`]: {
    fontSize: 24,
    padding: "0 3rem 1rem 0.5rem",
    fontFamily: "AvenirLTStd-Roman",
    gap: "1%",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      padding: "0 2rem 1rem 0.5rem",
    },
  },
  [`& .${classes.highlight}`]: {
    color: "red",
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.pointsContainer}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
  },
  [`& .${classes.blueContainer}`]: {
    background: "#F0F8FF",
    height: "100%",
    padding: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${classes.carouselBlock}`]: {
    height: "auto",
    padding: "2em 0 0 5em",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: "1em 0",
      background: "transparent",
    },
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: "2.5em 0 0 0",
    },
  },
  [`& .${classes.carouselImage}`]: {
    background: `url(${AircraftBackground}) -60% 100% no-repeat padding-box`,
    backgroundSize: "contain",
    width: 500,
    height: 500,
    maxWidth: "initial",
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: 500,
    },
  },
  [`& .${classes.carouselContainerLists}`]: {
    height: 600,
    overflow: "hidden",
    position: "relative",
    right: "8%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
      margin: "auto",
      right: "5%",
    },
  },
  [`& .${classes.fingertipTitle}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Roman",
    left: "0.7em",
    width: "70%",
    fontSize: 35,
    fontWeight: 100,
    padding: "40px 0 0 15px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      textAlign: "center",
      fontSize: 22,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "45%",
      fontSize: 30,
    },
    [theme.breakpoints.between("md", "lg")]: {
      width: "40%",
      fontSize: 35,
    },
  },
  [`& .${classes.fingertipTitleSubHeading}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Book",
    left: "0.7em",
    color: "grey",
    width: "70%",
    fontSize: 15,
    fontWeight: 10,
    paddingTop: "10px",
    paddingLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      paddingLeft: "0px",
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "55%",
    },
    [theme.breakpoints.between("lg", "xl")]: {
      width: "40%",
    },
  },
  [`& .${classes.fingertipTitle2Grid}`]: {
    display: "flex",
    justifyContent: "left",
    backgroundColor: "#fefbfb",
    paddingBottom: "0.7em",
  },
  [`& .${classes.sliderDiv}`]: {
    marginBottom: "-9em",
    [theme.breakpoints.between("xs", "md")]: {
      marginBottom: "0em",
    },
  },
  [`& .${classes.fingertipTitle2}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Roman",
    left: "0.7em",
    width: "60%",
    fontSize: 35,
    fontWeight: 100,
    paddingLeft: "15px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      textAlign: "left",
      fontSize: 22,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "45%",
      fontSize: 30,
    },
    [theme.breakpoints.between("md", "lg")]: {
      width: "40%",
      fontSize: 35,
    },
  },
  [`& .${classes.clientsHeading}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Roman",
    left: "0.7em",
    width: "60%",
    fontSize: 35,
    fontWeight: 100,
    paddingLeft: "15px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      textAlign: "right",
      fontSize: "2rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "45%",
    },
    [theme.breakpoints.between("md", "lg")]: {
      width: "40%",
    },
  },
  [`& .${classes.homePageTitle}`]: {
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    padding: "3em 0.5em 0 1em",
    width: "90%",
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 35,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 0,
      padding: 0,
      textAlign: "center",
      fontSize: 25,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "0.5em 0.5em 0 1em",
      width: "100%",
      marginTop: "10%",
      fontSize: 30,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 40,
    },
  },
  [`& .${classes.homePageTitledesc}`]: {
    padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginTop: "1em",
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.buttonStyles}`]: {
    textTransform: "inherit",
    width: 400,
    fontSize: 20,
  },
  [`& .${classes.homeButtonItem}`]: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      margin: "1em 0 1em 0",
      justifyContent: "center",
      display: "flex",
    },
  },
  [`& .${classes.exploreButtonStyle}`]: {
    whiteSpace: "nowrap",
    background: "#B41E1C",
    color: "#fff",
    fontWeight: "none",
    marginLeft: "1.5em",
    fontFamily: "AvenirLTStd-Roman",
    "&:hover": {
      background: "#fff",
      color: "#B41E1C",
      boxShadow: "5px 5px 13px 5px rgba(0,0,0,0.15)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
      marginLeft: 0,
      fontSize: 15,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: 350,
      fontSize: 20,
    },
    [theme.breakpoints.up("lg", "xl")]: {
      fontSize: 20,
    },
  },
  [`& .${classes.demoButtonGrid}`]: {
    display: "flex",
    justifyContent: "left",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  [`& .${classes.demoButtonStyle}`]: {
    textTransform: "inherit",
    fontFamily: "AvenirLTStd-Roman",
    width: 200,
    fontSize: 20,
    background: "#fff",
    color: "#B41E1C",
    border: "1px solid #B41E1C",
    fontWeight: "none",
    "&:hover": {
      background: "#fff",
      color: "#B41E1C",
      boxShadow: "5px 5px 13px 5px rgba(0,0,0,0.15)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 150,
      margin: "1em 0 0 0em",
      fontSize: 15,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: 200,
      margin: "2em 0 0 0em",
    },
  },
  [`& .${classes.productTabLabel}`]: {
    textTransform: "capitalize",
    fontSize: 32,
    fontFamily: "AvenirLTStd-Roman",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
      paddingRight: "1em",
      fontSize: 20,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 28,
    },
  },
  [`& .${classes.productTabSelected}`]: {
    color: "#000 !important",
  },
  [`& .${classes.backgroundDesign1}`]: {
    padding: "0.4em",
  },
  [`& .${classes.backgroundDesign2}`]: {
    background: `transparent url(${BackgroundImageBottom}) -40% 106% no-repeat padding-box`,
  },
  [`& .${classes.exploreProductLink}`]: {
    textAlign: "left",
    padding: "1em 1em 1em 1.2em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1em",
    },
  },
  [`& .${classes.tabContainerBlock}`]: {
    padding: "3em 24px 24px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 1em 0 !important",
    },
  },
  [`& .${classes.buttonContainer}`]: {
    marginTop: "1em",
  },
  [`& .${classes.productTabsContainer}`]: {
    padding: "0 24px 0 52px",
    marginTop: "5em",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      marginTop: "2em",
    },
  },
  [`& .${classes.productTabsDesc}`]: {
    padding: "1em",
    fontFamily: "AvenirLTStd-Book",
    fontSize: 24,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.tabContainerTabs}`]: {
    marginLeft: "0.5em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  [`& .${classes.productImage}`]: {
    minHeight: 200,
    minWidth: 200,
    maxWidth: "initial",
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: "auto",
      marginTop: "1em",
    },
  },
  [`& .${classes.productImageCoreCommand}`]: {
    height: 560,
    width: 890,
    position: "relative",
    left: -165,
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "md")]: {
      maxWidth: "100%",
      width: 400,
      height: 500,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.productImageOtherThanCoreCommand}`]: {
    height: 550,
    width: 650,
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "md")]: {
      maxWidth: "100%",
      width: 400,
      height: 500,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.exploreAnchorLink}`]: {
    textDecoration: "none",
    color: "#B41E1C",
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 26,
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
    "@media (min-width: 375px)": {
      fontSize: 22,
    },
    "@media (min-width: 800px)": {
      fontSize: 30,
    },
    "@media (min-width: 1280px)": {
      fontSize: 35,
    },
  },
}));

const Point = ({ text, highlight }) => {
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  return (
    <StyledBox display="flex" alignItems="flex-start" mb={2}>
      <CheckCircleIcon className={classes.icon} />
      <Typography className={classes.pointsBody}>
        {parts.map((part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={index} className={classes.highlight}>
              {part}
            </span>
          ) : (
            part
          )
        )}
      </Typography>
    </StyledBox>
  );
};

const OpsPage = () => {
  useEffect(() => {
    loadCarousel();
  }, []);

  const loadCarousel = () => {
    $(".my-flipster").not(".slick-initialized").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      infinite: true,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  };

  const handleEmailClick = () => {
    const subject = encodeURIComponent("REDiFly Product Demo Request");
    const email = "sales@redifly.com";
    const mailtoLink = `mailto:${email}?subject=${subject}`;
    window.location.href = mailtoLink;
  };

  return (
    <Layout>
      <div>
        <StyledGrid container className={classes.indexCarousrlBlockContainer}>
          <Grid size={{ xs: 12, md: 12, sm: 12, lg: 12 }}>
            <SmsSnippet />
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ padding: "0 3rem 0 3rem", margin: "0 1rem 0 1rem" }}
            >
              <Grid size={{ xs: 12, md: 6 }}>
                <StyledBox className={classes.pointsContainer}>
                  <Box sx={{ mt: 4 }}>
                    <Point
                      text="Spreadsheets create chaos. Disorganised data and lost files make it nearly impossible to track safety, manage risks, or make confident decisions."
                      highlight="Spreadsheets create chaos."
                    />
                    <Point
                      text="Outdated systems frustrate users. Clunky, slow interfaces with endless loading times discourage reporting and waste valuable time."
                      highlight="Outdated systems frustrate users."
                    />
                  </Box>
                </StyledBox>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <StyledBox className={classes.pointsContainer}>
                  <Box sx={{ mt: 4 }}>
                    <Point
                      text="Complexity overwhelms teams. Many SMS platforms are bloated with unnecessary steps and features, distracting users from what really matters—managing your safety."
                      highlight="Complexity overwhelms teams."
                    />
                    <Point
                      text="Excel and email limit insights. Without robust data analysis tools, critical trends go unnoticed, and opportunities to improve safety and efficiency are missed."
                      highlight="Excel and email limit insights."
                    />
                  </Box>
                </StyledBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ProfileComponent smsPage={true} />
          </Grid>
          <div
            style={{
              margin: "2% auto 0 auto",
              borderRadius: "45px",
              background: "#F0F8FF",
              padding: "16px",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "80%",
              marginBottom: "2%",
            }}
            sx={{
              width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" },
            }}
          >
            <Grid
              className={classes.blueContainer}
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
              }}
              // data-aos="fade-up"
              // data-aos-duration="3000"
            >
              <Typography
                variant="body"
                sx={{
                  width: "80%",
                  fontWeight: 400,
                  fontFamily: "AvenirLTStd-Book",
                  fontSize: {
                    xs: "16px",
                    sm: "20px",
                    md: "20px",
                    lg: "20px",
                  },
                  lineHeight: "180%",
                  padding: "1%",
                }}
              >
                Our system simplifies safety management with four seamlessly
                integrated modules, built to empower small-to-medium operations
                to manage safety-without the complications.
              </Typography>
            </Grid>
          </div>
          <Grid size={{ xs: 12 }}>
            <ModulesTabSectionContent />
          </Grid>

          {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <Typography variant="h2" className={classes.fingertipTitle}>
              Streamlined end-to-end solution complete with seamless
              integrations
            </Typography>
            <Typography className={classes.fingertipTitleSubHeading}>
              Our Flight Operations suite enables enhanced connectivity and data
              visibility across all departments.
            </Typography>
          </Grid> */}
          {/* <ProductFeatures featureData={OpsFeaturesData} /> */}
          {/* <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={classes.fingertipTitle2Grid}
          >
            <Typography variant="h2" className={classes.fingertipTitle2}>
              Customised workflows with efficient & configurable automation.
            </Typography>
          </Grid> */}
          {/* <WinopsTabSection /> */}
          {/* <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={classes.fingertipTitle2Grid}
          >
            <Typography variant="h2" className={classes.fingertipTitle2}>
              Our Apps
            </Typography>
          </Grid>
          <WinopsApps /> */}
          {/* <LogoCarousel /> */}
          {/* <Grid size={{ xs: 12 }}>
            <ProductBenefits benefitsData={OpsBenefitsData} />
          </Grid> */}
          {/* <Typography variant="h2" className={classes.fingertipTitle2}>
            Our Integrations
          </Typography> */}
          {/* <Grid size={{ xs: 12 }}>
            <IntegrationCarousel />
          </Grid> */}
          {/* <Grid size={{ xs: 12 }}>
            <CustomerReviews customerReviewData={OpsCustomerData} />
          </Grid> */}
          <Grid size={{ xs: 12 }}>
            <SmsWorkshop />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TalktoUs />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <DiscoverSection />
          </Grid>
        </StyledGrid>
      </div>
    </Layout>
  );
};

export default OpsPage;
